module.exports = __webpack_public_path__ + "images/fa-cfa-instructor-peter-lipovyanov.webp";